export default "__VITE_ASSET__hLn2HB$f__"